module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"recording":"Идёт запись"}}')
  delete Component.options._Ctor
}
